import { useState } from 'react';
import { Link } from 'react-router-dom';
import { nomeCompleto } from '@adega/shared';
import { AiConfigBanner, ErrorBox } from '../components/Feedback.js';
import { PageHeader } from '../components/PageHeader.js';
import { useAiStatus, useSuggestPairing } from '../api/queries.js';

const SUGESTOES_RAPIDAS = [
  'Churrasco de picanha',
  'Massa com molho de tomate',
  'Peixe grelhado com limão',
  'Risoto de cogumelos',
  'Queijos e frios',
  'Feijoada',
];

export function WhatToEat() {
  const { data: aiStatus } = useAiStatus();
  const sugerir = useSuggestPairing();
  const [refeicao, setRefeicao] = useState('');

  const resultado = sugerir.data;

  return (
    <div className="space-y-4">
      <PageHeader titulo="Harmonizar" subtitulo="O que você vai comer?" />
      <p className="text-sm text-adega-muted">
        Descreva o prato e eu indico qual garrafa das suas adegas abrir — e onde ela está.
      </p>

      <AiConfigBanner contexto="A sugestão por refeição depende da IA." />

      <section className="card space-y-3">
        <textarea
          rows={3}
          className="field"
          value={refeicao}
          disabled={!aiStatus?.enabled}
          onChange={(e) => setRefeicao(e.target.value)}
          placeholder="Ex.: costela assada lentamente com batata rústica e alecrim"
        />

        <div className="flex flex-wrap gap-1.5">
          {SUGESTOES_RAPIDAS.map((item) => (
            <button
              key={item}
              type="button"
              disabled={!aiStatus?.enabled}
              onClick={() => setRefeicao(item)}
              className="rounded-full border border-adega-border px-3 py-1 text-xs text-adega-muted transition hover:border-adega-wine-light hover:text-adega-text disabled:opacity-40"
            >
              {item}
            </button>
          ))}
        </div>

        <button
          type="button"
          className="btn-primary w-full"
          disabled={!aiStatus?.enabled || sugerir.isPending || refeicao.trim().length < 3}
          onClick={() => void sugerir.mutateAsync(refeicao.trim())}
        >
          {sugerir.isPending ? 'Escolhendo…' : '🍽️ Sugerir vinho da minha adega'}
        </button>
      </section>

      {sugerir.error ? <ErrorBox erro={sugerir.error} /> : null}

      {resultado ? (
        <section className="space-y-3">
          <h2 className="font-semibold">Para “{resultado.refeicao}”</h2>

          {resultado.comentarioGeral ? (
            <p className="text-sm text-adega-muted">{resultado.comentarioGeral}</p>
          ) : null}

          {resultado.sugestoes.map((sugestao, indice) => (
            <article key={sugestao.bottle.id} className="card space-y-2">
              <div className="flex items-start gap-3">
                <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-adega-wine text-sm font-bold">
                  {indice + 1}
                </span>

                <div className="min-w-0 flex-1">
                  <Link
                    to={`/garrafa/${sugestao.bottle.id}`}
                    className="font-semibold hover:text-adega-gold"
                  >
                    {nomeCompleto(sugestao.bottle)}
                    {sugestao.bottle.vintage ? ` ${sugestao.bottle.vintage}` : ''}
                  </Link>
                  {/* A posição física é o ponto do recurso: saber onde pegar a garrafa. */}
                  <p className="text-xs text-adega-gold">
                    📍 {sugestao.bottle.positionLabel ?? 'Sem posição definida'}
                  </p>
                </div>

                <span className="shrink-0 text-sm text-adega-muted">{sugestao.score}</span>
              </div>

              <p className="text-sm leading-relaxed">{sugestao.justificativa}</p>

              {sugestao.comoServir ? (
                <p className="rounded-lg bg-adega-surface-2 px-3 py-2 text-xs text-adega-muted">
                  {sugestao.comoServir}
                </p>
              ) : null}
            </article>
          ))}
        </section>
      ) : null}
    </div>
  );
}
